import React, {useEffect} from 'react'
import styled from '@emotion/styled'

const QrCodeWrapper = styled.div<{size: number}>`
  canvas {
    width: ${({size}) => size}px;
    height: ${({size}) => size}px;
  }
`

interface QrCodeProps {
  size?: number
}

const QR_CODE_ID = 'QRCodeId'

export const QrCode = ({size = 145}: QrCodeProps) => {
  useEffect(() => {
    window.AF_SMART_SCRIPT.displayQrCode(QR_CODE_ID)
  }, [])

  return (
    <QrCodeWrapper id={QR_CODE_ID} size={size} data-id="QRCode"></QrCodeWrapper>
  )
}
